<div class="page-layout blank fullwidth" >
  <div class="my-request">
    <!-- <mat-progress-bar class="mt-8" mode="indeterminate"></mat-progress-bar> -->
    <div class="container">
      <div class="main-content">
        <div class="my-booking-page-name-and-search-div" *ngIf="!isMobile">
          <h2 class="title">📋 My Customer Bookings</h2>
          <div class="search">
                <div class="input-container">
                  <!-- <input type="text" class="search-input" [(ngModel)]="searchText" (keydown.enter)="onSearch()" (input)="filterRequests()"> -->
                  <input type="text" class="search-input" [(ngModel)]="searchText" (ngModelChange)="onInputChange()" (click)="isInputVisible = true">
                  <span *ngIf="searchText" class="close-button" (click)="clearSearch()">✖</span>
                  <div class="scroll-text-container"  *ngIf="!isInputVisible && !searchText">
                    <div class="SearchBarIcon">
                      <i class="material-icons-search">search</i>
                    </div>
                    <div class="scroll-text">
                      <div id="animationText-1" class="SearchBarAnimationText">Search By "Booking ID"</div>
                      <div id="animationText-2" class="SearchBarAnimationText">Search By "Name"</div>
                      <div id="animationText-3" class="SearchBarAnimationText">Search By "Mobile Number"</div>
                      <div id="animationText-4" class="SearchBarAnimationText">Search By "Registration Number"</div>
                    </div>
                  </div>
                </div>
                <!-- <button class="create-booking" (click)="toggleSidebar()"><mat-icon class="addd-mat-btn">add</mat-icon> 
                  <button class="search-request-btn" (click)="toggleSidebar()">Create Booking</button>
                </button> -->
                <button class="create-booking" (click)="toggleSidebar()">
                <mat-icon style="font-size: 18px;  display: flex;  align-items: center;">add</mat-icon>
                Create Booking
              </button>

          </div>
        </div>
        <div class="my-booking-page-name-and-search-div" *ngIf="isMobile">
          <h2 class="title">📋 My Customer Bookings</h2>
          <!-- <button class="create-booking" (click)="toggleSidebar()"><mat-icon class="addd-mat-btn">add</mat-icon> 
                  <button class="search-request-btn" (click)="toggleSidebar()">Create Booking</button>
          </button> -->
          <button class="create-booking" (click)="toggleSidebar()">
                <mat-icon style="font-size: 18px;  display: flex;  align-items: center;">add</mat-icon>
                Create Booking
          </button>
        </div>
        <div class = "isMobilesearch-and-filter" *ngIf="isMobile"> 
          <div class="search">
                <div class="input-container">
                  <!-- <input type="text" class="search-input" [(ngModel)]="searchText" (keydown.enter)="onSearch()" (input)="filterRequests()"> -->
                  <input type="text" class="search-input" [(ngModel)]="searchText" (keydown.enter)="onSearch()" (ngModelChange)="onInputChange()">
                  <span *ngIf="searchText" class="close-button" (click)="clearSearch()">✖</span>
                  <div class="scroll-text-container" *ngIf="!searchText">
                    <div class="SearchBarIcon">
                      <i class="material-icons-search">search</i>
                    </div>
                    <div class="scroll-text">
                      <div id="animationText-1" class="SearchBarAnimationText">Search By "Booking ID"</div>
                      <div id="animationText-2" class="SearchBarAnimationText">Search By "Name"</div>
                      <div id="animationText-3" class="SearchBarAnimationText">Search By "Mobile Number"</div>
                    </div>
                  </div>
                </div>
          </div>
          <span  (click)="sidecontainer()" class="filterslist">
              <mat-icon class="filterslist-mat-icon">filter_list</mat-icon>
            Filters
        </span>
        </div>
        <div class="filter-panel-main">
          <aside class="filter-panel" *ngIf="!isMobile">
            <div class="filter-header">
              <div class="filter-title">
                <span>⚙️ Filters</span>
              </div>
              <!-- <button class="clear-all-btn" (click)="clearRequestTimeFilter()">Clear all</button> -->
              <button  class="clear-all-btn" *ngIf="selectedRequestTimeLabel" (click)="clearRequestTimeFilter()">  Clear all</button>

            </div>
            <!-- Applied Filter -->
            <div class="applied-filters" *ngIf="selectedRequestTime">
              <span class="filter-chip">
                <div class="selected-filter">{{ selectedRequestTimeLabel }}</div>
                <mat-icon class="chip-close" (click)="clearRequestTimeFilter()">close</mat-icon>
              </span>
            </div>
            <!-- Booking Date -->
          <div class="filter-section">
            <h4>Request Time</h4>

            <div class="request-time-list">

            <label class="time-option">
              <span class="label-text">Today</span>
              <input
                type="radio"
                name="requestTime"
                [(ngModel)]="selectedRequestTime"
                value="TODAY"
                (change)="onRequestTimeChange('TODAY')"
              />
              <span class="custom-radio"></span>
            </label>

            <label class="time-option">
              <span class="label-text">Yesterday</span>
              <input
                type="radio"
                name="requestTime"
                [(ngModel)]="selectedRequestTime"
                value="YESTERDAY"
                (change)="onRequestTimeChange('YESTERDAY')"
              />
              <span class="custom-radio"></span>
            </label>

            <label class="time-option">
              <span class="label-text">Last 7 days</span>
              <input
                type="radio"
                name="requestTime"
                [(ngModel)]="selectedRequestTime"
                value="LAST_7_DAYS"
                (change)="onRequestTimeChange('LAST_7_DAYS')"
              />
              <span class="custom-radio"></span>
            </label>

            <label class="time-option">
              <span class="label-text">Last 30 days</span>
              <input
                type="radio"
                name="requestTime"
                [(ngModel)]="selectedRequestTime"
                value="LAST_30_DAYS"
                (change)="onRequestTimeChange('LAST_30_DAYS')"
              />
              <span class="custom-radio"></span>
            </label>

            <label class="time-option">
              <span class="label-text">This month</span>
              <input
                type="radio"
                name="requestTime"
                [(ngModel)]="selectedRequestTime"
                value="THIS_MONTH"
                (change)="onRequestTimeChange('THIS_MONTH')"
              />
              <span class="custom-radio"></span>
            </label>

            <label class="time-option">
              <span class="label-text">Last Month</span>
              <input
                type="radio"
                name="requestTime"
                [(ngModel)]="selectedRequestTime"
                value="LAST_MONTH"
                (change)="onRequestTimeChange('LAST_MONTH')"
              />
              <span class="custom-radio"></span>
            </label>

            <label class="time-option">
              <span class="label-text">Any Time</span>
              <input
                type="radio"
                name="requestTime"
                [(ngModel)]="selectedRequestTime"
                value="ANY_TIME"
                (change)="onRequestTimeChange('ANY_TIME')"
              />
              <span class="custom-radio"></span>
            </label>

          </div>
          </div>
          </aside>
          <div class="SearchBarPlaceholder" *ngIf="requestList?.length > 0">
          <!-- Sidebar controlled by *ngIf -->
          <div class="overlay" [class.visible]="isSidebarOpen" (click)="toggleSidebar()"></div> 
          
            <div class="sidebar" *ngIf="isSidebarOpen">
                <div class="sidebar-content">
                  <div class="sidebarheading1" >
                    <div class="sidebarheading">
                      <mat-icon  (click)="toggleSidebar()" class="bckbtnnew">keyboard_backspace</mat-icon>
                      <h2 class="crtbkng">Create Booking</h2>
                      <!-- <button class="close-sidebar" (click)="toggleSidebar()">×</button> -->
                      <mat-icon class="close-sidebar" (click)="toggleSidebar()">close</mat-icon>
                    </div>
                  </div>
                  <!-- <hr /> -->
                  <!-- <form #bookingForm="ngForm" (ngSubmit)="onSubmit(bookingForm)" >
                    <div class="form-group">
                      <input type="text" id="name" placeholder="Name *" required [(ngModel)]="customerName" name="customerName" #name="ngModel" pattern="[a-zA-Z ]*">
                      <small>Your Customer Name</small>
                      <div *ngIf="(name.invalid && name.touched) || (name.invalid && formSubmitted)" style="color: red;" >
                        Enter Valid Customer Name 
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="mbl-number">
                        Mobile Number <span class="required">*</span>
                      </div>              
                      <input type="text" id="mobile" placeholder="+91" required pattern="^\d{10}$" [(ngModel)]="customerMobile" name="customerMobile" #mobile="ngModel" pattern="[0-9]*" maxlength="10">
                      <small>Minimum 10 digits required</small>
                      <div *ngIf="(mobile.invalid && mobile.touched) || (mobile.invalid && formSubmitted)" style="color: red;">
                        Enter Valid Mobile Number
                      </div>
                    </div>
                    <button type="submit" class="submit-btn">Create Booking</button>
                  </form> -->
                  <form #bookingForm="ngForm" (ngSubmit)="onSubmit(bookingForm)">
                    <div class="bookingForm1">
                      <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true" class="bookingForm1-mat">
                        <mat-label>
                          Customer Name <span class="required-asterisk">*</span>
                        </mat-label>
                        <input
                          matInput
                          [(ngModel)]="customerName"
                          name="customerName"
                          required
                          id="customerName"
                          pattern="[a-zA-Z ]*"
                          #name="ngModel"
                        />
                        <mat-error *ngIf="(name.invalid && name.touched) || (name.invalid && formSubmitted)">
                          Enter Valid Customer Name
                        </mat-error>
                      </mat-form-field>
                  
                      <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true" >
                        <mat-label>
                          Mobile Number <span class="required-asterisk">*</span>
                        </mat-label>
                        <input
                          matInput
                          [(ngModel)]="customerMobile"
                          name="customerMobile"
                          required
                          id="customerMobile"
                          pattern="^\d{10}$"
                          maxlength="10"
                          #mobile="ngModel"
                          type="tel"
                          inputmode="numeric"
                        />
                        <mat-error *ngIf="(mobile.invalid && mobile.touched) || (mobile.invalid && formSubmitted)">
                          Enter Valid Mobile Number
                        </mat-error>
                      </mat-form-field>
                    </div>
                  <div class="sbmtbtn"  [ngClass]="{ 'button-container': true, 'button-keyboard-open': isKeyboardOpen }">
                    <button type="submit" class="submit-btn">Create Booking</button>
                  </div>
                  
                  </form>
                  
                </div>
            </div>

          <!-- Pop-up content -->
          <div class="popup" *ngIf="isPopupOpen">
            <div class="popup-content order-success-sec">
              <!-- <button mat-button (click)="closePopup()">Close</button> -->
              <img src="{{ successIcon }}" alt="Success Icon">
              <!-- <button class="close-popup" (click)="closePopup()">×</button> -->
              <mat-icon class="close-popup" (click)="closePopup()">close</mat-icon>

              <h3>Booking Created!</h3>
              <p class="order-label"><span class="order-id">Booking ID# {{orderID.bookingId}}</span></p>
              <p class="date"><span>{{orderID.createdAt | date:'dd MMM yyyy, hh:mm a'}}</span></p>
              <p class="thank-you">Let us deliver an awesome experience!</p>
              <button class="goto-order" (click)="closePopup()">OK, GOT IT </button>
            </div>
          </div>
          <!-- Other content -->
            <div class="header" *ngFor="let request of requestList" >
              <div class="header-row" >
                <div class="request-info">
                  <div class="header-top-row">
                    <div class="order-icon">
                      <!-- <i class="top-material-icons">check_box</i> -->
                      <svg style ="  width: 36px;    height: 36px;opacity: 1;  top: 196px; left: 333px; border-radius: 12px;    background: linear-gradient(90deg, #E8F2FF 100%, #D7F5FC 0%); padding: 7px;    box-shadow: 0px 1px 0px 0px #FFFFFF;" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.47461 3.59735H3.47461C2.94418 3.59735 2.43547 3.80806 2.0604 4.18314C1.68532 4.55821 1.47461 5.06692 1.47461 5.59735V17.5974C1.47461 18.1278 1.68532 18.6365 2.0604 19.0116C2.43547 19.3866 2.94418 19.5974 3.47461 19.5974H13.4746C14.005 19.5974 14.5137 19.3866 14.8888 19.0116C15.2639 18.6365 15.4746 18.1278 15.4746 17.5974V5.59735C15.4746 5.06692 15.2639 4.55821 14.8888 4.18314C14.5137 3.80806 14.005 3.59735 13.4746 3.59735H11.4746M5.47461 3.59735C5.47461 4.12778 5.68532 4.63649 6.0604 5.01156C6.43547 5.38664 6.94418 5.59735 7.47461 5.59735H9.47461C10.005 5.59735 10.5137 5.38664 10.8888 5.01156C11.2639 4.63649 11.4746 4.12778 11.4746 3.59735M5.47461 3.59735C5.47461 3.06692 5.68532 2.55821 6.0604 2.18314C6.43547 1.80806 6.94418 1.59735 7.47461 1.59735H9.47461C10.005 1.59735 10.5137 1.80806 10.8888 2.18314C11.2639 2.55821 11.4746 3.06692 11.4746 3.59735M8.47461 10.5974H11.4746M8.47461 14.5974H11.4746M5.47461 10.5974H5.48461M5.47461 14.5974H5.48461" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div class="book-id">Booking ID# {{request.bookingId}}</div>
                    <div class="right-container">
                      <div class="right-container-icon" (click)="shareOnWhatsApp(request)">
                        <mat-icon class="share-icon">share</mat-icon>
                        <div class="share-txt">Share Details</div>
                      </div>
                      <!-- <div class="right-container-icon" (click)="openRecordPaymentSidebar()" >Record Payment</div>         -->
                    </div>
                  </div>
                  <div class="name-mbl-num">
                    <div class="nam-and-coupon">
                      <!-- <div class="name">{{ request.name }}</div> -->
                      <div class="name">
                        {{ request.name ? (request.name.charAt(0).toUpperCase() + request.name.slice(1).toLowerCase()) : 'NA' }}
                      </div>

                      <div class="tag-and-coupon-code" *ngIf="request.tagDeal" >
                        <div class="tag" *ngIf="request.tagDeal" >{{request.tag }}</div>
                        <div class="coupon-code" *ngIf="request.tagDeal" >{{request.couponCode }}</div>
                      </div>
                    </div>
                    <div style="display: flex; gap: 5px; align-items: center;">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H5.52C5.65986 2.00011 5.79615 2.0442 5.90957 2.12603C6.02299 2.20787 6.1078 2.3233 6.152 2.456L7.15067 5.45133C7.20127 5.60356 7.19528 5.76893 7.13381 5.9171C7.07234 6.06527 6.9595 6.1863 6.816 6.258L5.31133 7.01133C6.04888 8.64369 7.35631 9.95112 8.98867 10.6887L9.742 9.184C9.8137 9.0405 9.93473 8.92766 10.0829 8.86619C10.2311 8.80472 10.3964 8.79873 10.5487 8.84933L13.544 9.848C13.6768 9.89223 13.7923 9.97714 13.8742 10.0907C13.956 10.2043 14 10.3407 14 10.4807V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H12C6.47733 14 2 9.52267 2 4V3.33333Z" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="mobile-number">{{ request.phoneNumber }}</div>
                    </div>
                    <div>
                      <div class="reg-number" *ngIf="request.registratioNumber">🚗 {{ request.registratioNumber | uppercase}}</div>
                    </div>
                  </div>
                  <div class="reported-issue-with-txt" *ngIf="request.issue">
                    <div class="nam-and-coupon">
                      <div class="rprtd-issue">Reported Issues</div>
                    </div>
                    <div>
                      <div class="req-issue">{{request.issue}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="header-row2">
                <!-- {{requestList | json}} -->
                <div class="placed-on-date">Booked on: {{ request.createdAt | date:'dd MMM yyyy, hh:mm a'}}</div>
                <a class="view-btn" style="float: right; border: none; background-color: white; color: #4caf50;" (click)="loadorderdetails(request.bookingId,request.name,request.phoneNumber)">
                  <!-- <span class="job-card" style="float: left;">Create Job Card</span> -->
                </a>
                  <!-- <a class="view-btn" href="/request-details/YourRequestID" style="float: right;border: none;background-color: white;color: #4caf50;"> -->
              </div>
            </div>
        </div>
        <div class="no-image-car">
            <div class="no-image-car"  *ngIf="!loading && (selectedRequestTime || searchText) && requestList?.length === 0">
            <img [src]="emptyList" alt="No data available" />
            <h1 class="no-request-text">No Bookings Found</h1>
            <div class="eidt-text">Edit filter or go back to my customers booking page</div>
            <button class="go-back-btn" (click)="clearSearch()" >Go to My Bookings</button>
          </div>
        </div>
      </div>
      <!-- FILTER SIDEBAR (Mobile) -->
      <div
        class="filter-overlay"
        *ngIf="isMobile && isFilterSidebarOpen "
        (click)="closeFilterSidebar()"
      ></div>

      <aside
        class="filter-panel mobile"
        *ngIf="isMobile && isFilterSidebarOpen"
      >
        <div class="filter-header">
          <div class="filter-title">⚙️ Filters</div>

          <button
            class="clear-all-btn"
            (click)="clearRequestTimeFilter()"
          >
            Clear all
          </button>
        </div>

        <!-- Applied filter -->
        <div class="applied-filters" >
          <span class="filter-chip">
            {{ selectedRequestTimeLabel }}
            <mat-icon class="chip-close" (click)="clearRequestTimeFilter()">
              close
            </mat-icon>
          </span>
        </div>

        <!-- Request Time -->
        <div class="filter-section">
          <h4>Request Time</h4>

          <div class="request-time-list">
            <label class="time-option" *ngFor="let item of requestTimeOptions">
              <span class="label-text">{{ item.label }}</span>
              <input  type="radio"  name="requestTime"  [(ngModel)]="tempRequestTime"  [value]="item.value"/>
              <span class="custom-radio"></span>
            </label>
          </div>
        </div>
        <div class="filter-footer">
          <button
            class="apply-filter-btn"
            [disabled]="!tempRequestTime"
            (click)="applyRequestTimeFilter()"
          >
            Apply Filters
          </button>
        </div>

      </aside>

    </div>
  <!-- Job Card Sidebar -->
  <div class="overlay" [class.visible]="isJobCardSidebarOpen" (click)="toggleJobCardSidebar()"></div>
  <div class="job-card-sidebar" *ngIf="isJobCardSidebarOpen">
    <form class="container">
      <!-- <label for="odometer" style="font-weight: bolder;">
        Enter Odometer Reading <span class="required">*</span>
      </label> -->
      <!-- <div class="input-group">
        <span class="small-img">
          <img src="assets/images/my-job-card-images/carkm.png" class="input-icon" alt="Car KM"> KM
        </span>
        <input id="odometer" type="text" placeholder="10000">
      </div>
      <small>Enter Odometer Reading</small> -->

      <label for="regNo" style="font-weight: bolder;">
        We recommend entering the car number <span class="required">*</span>
      </label>
      <div class="input-group">
        <span class="small-img">
          <img src="assets/images/my-job-card-images/circle.png" class="input-icon" alt="Car Number"> IND
        </span>
        <input id="regNo" placeholder="KA 04 JA54**" maxlength="13" style="font-weight: 800;">
      </div>
      <small>Please enter car number</small>

      <!-- <div class="action-buttons">
        <button mat-icon-button>
          <mat-icon>camera_alt</mat-icon> Scan
        </button>
        <button mat-icon-button>
          <mat-icon>mic</mat-icon> Voice
        </button>
      </div> -->

      <ul class="info-list">
        <li>
          <mat-icon class="circle">check_circle</mat-icon>
          <span class="get">Get accurate details</span>
        </li>
        <li>
          <mat-icon class="circle">check_circle</mat-icon>
          <span class="get">Get 2X faster results</span>
        </li>
      </ul>

      <button mat-raised-button color="accent" class="submit-btn" aria-label="VEHICLE">
        FIND MY CAR
      </button>
      <p class="manual-selection">Or select car manually</p>
    </form>
  </div>


  <!-- Confirmation Sidebar -->
  <div class="overlay" [class.visible]="isConfirmationSidebarOpen" (click)="toggleConfirmationSidebar()"></div>
  <div class="confirmation-sidebar" *ngIf="isConfirmationSidebarOpen">
      <div class="confirmation-content">
          <div class="header-container">
              <mat-icon class="back-arrow" (click)="toggleConfirmationSidebar()">arrow_back</mat-icon>
              <mat-icon style="color: #144579;">directions_car</mat-icon>
              <img src="../../../../assets/images/my-job-card-images/img_share.png" alt="">
          </div>
          <h3>Confirm your car details</h3>
          <div class="details-item">
              <img src="../../../../assets/images/my-job-card-images/ic_check.png" class="circle-img" alt="">
              <div class="label">Make:</div>
              <div class="value">{{ jobCard.make }}</div>
          </div>
          <div class="details-item">
              <img src="../../../../assets/images/my-job-card-images/ic_check.png" alt="">
              <div class="label">Model:</div>
              <div class="value">{{ jobCard.model }}</div>
          </div>
          <div class="details-item">
              <img src="../../../../assets/images/my-job-card-images/ic_check.png" alt="">
              <div class="label">Variant:</div>
              <div class="value">{{ jobCard.variant }}</div>
          </div>
          <div class="details-item">
              <img src="../../../../assets/images/my-job-card-images/ic_check.png" alt="">
              <div class="label">MFG Year:</div>
              <div class="value">{{ jobCard.mfgYear }}</div>
          </div>
          <div class="details-item">
              <img src="../../../../assets/images/my-job-card-images/ic_check.png" alt="">
              <div class="label">Fuel:</div>
              <div class="value">{{ jobCard.fuelType }}</div>
          </div>
          <div class="details-item">
              <img src="../../../../assets/images/my-job-card-images/ic_check.png" alt="">
              <div class="label">VIN:</div>
              <div class="value">{{ jobCard.vin }}</div>
          </div>
          <button class="confirm-btn" (click)="confirmCarDetails()">Confirm</button>
          <button class="change-car-btn" (click)="toggleConfirmationSidebar()">Change Car</button>
      </div>
  </div>

  </div>
  </div>
</div>
<div #dynamicContainer></div>
<!-- <ng-template #dynamicContainer></ng-template> -->
